// free-product-logic.js (UNIFIED Multi-Collection Free Gift Logic)

document.addEventListener('DOMContentLoaded', function() {
    const FREE_GIFT_PROPERTY_KEY = '_free_gift';
    const FREE_GIFT_PROPERTY_VALUE = 'true';

    // ============================================
    // CONFIGURATION: Define your gift tiers here
    // ============================================
    const GIFT_TIERS = [
        {
            name: 'Collection 1 - Rs. 12,000 Tier',
            threshold: 12000,
            freeGiftVariantId: 52099680239930, // <<< FREE GIFT for Collection 1
            eligibleProductIds: [
                9876754235706, 9876754301242, 9876755087674, 9876755153210,
                9876755382586, 9876757446970, 9876757643578, 9876757709114,
                9876757905722, 9895084392762, 9895084425530, 9895084523834,
                9895084556602, 9895085310266, 9895085343034, 9895085932858,
                9895086063930, 9903947678010, 9910586605882, 9982000398650,
                9997926302010, 9997939376442, 9997946552634, 9997947371834,
                10012310143290, 10012369977658, 10012382429498, 10051093987642,
                10051094380858, 10051095986490, 10051096215866, 10051096576314,
                10051096903994, 10051097035066, 10051097133370, 10051097166138,
                10051097329978, 10051097395514, 10051097788730, 10051097952570,
                10051099394362, 10051099590970, 10051100410170
            ],
            eligibleVariantIds: [], // Optional: specific variant IDs
            eligibleProductHandles: [] // Optional: product handles from collection
        },
        {
            name: 'Collection 2 - Rs. 15,000 Tier',
            threshold: 600,
            freeGiftVariantId: 52099684172090, // <<< FREE GIFT for Collection 2 (REPLACE WITH ACTUAL ID)
            eligibleProductIds: [
                10050838004026,
10050834170170,
10025181905210,
9876851491130,
9876850803002,
9876850704698,
10025166242106,
9876850999610,
9876850508090,
9876850540858,
9876851065146,
9876851949882,
9876850671930,
9876851818810,
9876851261754,
9876850606394,
9876850934074,
9876851654970,
9876850966842,
9876850868538,
9876851425594,
9876851589434
            ],
            eligibleVariantIds: [],
            eligibleProductHandles: []
        },
        {
            name: 'Collection 3 Any order',
            threshold: 500,
            freeGiftVariantId: 52111425569082, // <<< FREE GIFT for Collection 2 (REPLACE WITH ACTUAL ID)
            eligibleProductIds: [
                10033412571450,10033401626938,9908045316410,10033406968122,10033401921850,10033406705978,10033409425722,10033414668602,10033413161274,10033415717178,10033410146618,10033410998586,10033408082234
            ],
            eligibleVariantIds: [],
            eligibleProductHandles: []
        }
        // Add more tiers as needed
    ];

    /*
     * Helper to trigger Dawn theme's native cart UI refreshes.
     */
    function triggerDawnCartRefresh() {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-product-logic' });
        } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
        }
    }

    /*
     * Fetches the current cart data using Shopify's AJAX API.
     */
    async function getCart() {
        try {
            const response = await fetch('/cart.js');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching cart:', error);
            return null;
        }
    }

    /*
     * Checks if a cart item is eligible for a specific tier
     */
    function isItemEligibleForTier(item, tier) {
        // Skip free gifts from eligibility check
        const hasFreeGiftProperty = item.properties && 
                                   item.properties[FREE_GIFT_PROPERTY_KEY] === FREE_GIFT_PROPERTY_VALUE;
        if (hasFreeGiftProperty) {
            return false;
        }

        // Check variant IDs (most specific)
        if (tier.eligibleVariantIds.length > 0 && tier.eligibleVariantIds.includes(item.variant_id)) {
            return true;
        }

        // Check product IDs
        if (tier.eligibleProductIds.length > 0 && tier.eligibleProductIds.includes(item.product_id)) {
            return true;
        }

        // Check product handles
        if (tier.eligibleProductHandles.length > 0) {
            const itemHandle = item.handle || '';
            if (tier.eligibleProductHandles.includes(itemHandle)) {
                return true;
            }
        }

        return false;
    }

    /*
     * Calculates eligible total and checks if threshold is met for each tier
     */
    function evaluateTiers(cart) {
        const tierStatuses = GIFT_TIERS.map(tier => {
            let eligibleTotal = 0;
            let hasEligibleProducts = false;
            const eligibleItems = [];

            // Calculate total for this tier's eligible products
            cart.items.forEach(item => {
                if (isItemEligibleForTier(item, tier)) {
                    hasEligibleProducts = true;
                    const itemTotal = item.final_line_price / 100;
                    eligibleTotal += itemTotal;
                    eligibleItems.push({
                        title: item.product_title,
                        quantity: item.quantity,
                        price: itemTotal
                    });
                }
            });

            const meetsThreshold = eligibleTotal >= tier.threshold;
            const shouldHaveGift = hasEligibleProducts && meetsThreshold;

            // Check if gift is currently in cart
            let giftInCart = false;
            cart.items.forEach(item => {
                const hasFreeGiftProperty = item.properties && 
                                          item.properties[FREE_GIFT_PROPERTY_KEY] === FREE_GIFT_PROPERTY_VALUE;
                if (item.variant_id === tier.freeGiftVariantId && hasFreeGiftProperty) {
                    giftInCart = true;
                }
            });

            // Log tier evaluation
            console.log(`\n--- ${tier.name} ---`);
            if (hasEligibleProducts) {
                console.log(`✓ Eligible products found:`);
                eligibleItems.forEach(item => {
                    console.log(`  - ${item.title} x${item.quantity} = Rs. ${item.price.toFixed(2)}`);
                });
                console.log(`Total: Rs. ${eligibleTotal.toFixed(2)} / Rs. ${tier.threshold}`);
                console.log(`Status: ${meetsThreshold ? '✓ Threshold met' : '✗ Below threshold'}`);
            } else {
                console.log(`✗ No eligible products in cart`);
            }

            return {
                tier,
                eligibleTotal,
                hasEligibleProducts,
                meetsThreshold,
                shouldHaveGift,
                giftInCart
            };
        });

        return tierStatuses;
    }

    /*
     * Adds a free gift to the cart
     */
    async function addFreeGift(variantId, tierName) {
        const itemsWithProperties = [{
            id: variantId,
            quantity: 1,
            properties: {
                [FREE_GIFT_PROPERTY_KEY]: FREE_GIFT_PROPERTY_VALUE
            }
        }];

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ items: itemsWithProperties })
            });
            
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.message || 'Unknown error'}`);
            }
            
            console.log(`✓ Added free gift for: ${tierName}`);
            return await response.json();
        } catch (error) {
            console.error(`Error adding free gift for ${tierName}:`, error);
            return null;
        }
    }

    /*
     * Removes a free gift from the cart
     */
    async function removeFreeGift(variantId, tierName) {
        const cart = await getCart();
        if (!cart) return;

        const itemsToRemove = {};
        let removalNeeded = false;

        cart.items.forEach(item => {
            const isFreeGift = item.variant_id === variantId;
            const hasFreeGiftProperty = item.properties && 
                                       item.properties[FREE_GIFT_PROPERTY_KEY] === FREE_GIFT_PROPERTY_VALUE;

            if (isFreeGift && hasFreeGiftProperty) {
                itemsToRemove[item.key] = 0;
                removalNeeded = true;
            }
        });

        if (removalNeeded) {
            try {
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ updates: itemsToRemove })
                });
                
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.message || 'Unknown error'}`);
                }
                
                console.log(`✗ Removed free gift for: ${tierName}`);
            } catch (error) {
                console.error(`Error removing free gift for ${tierName}:`, error);
            }
        }
    }

    /*
     * Main logic: Evaluates all tiers and manages free gifts
     */
    async function manageAllFreeGifts() {
        const cart = await getCart();
        if (!cart) return;

        console.log('=== Free Gift Logic Evaluation ===');
        
        const tierStatuses = evaluateTiers(cart);
        let changesNeeded = false;

        // Process each tier
        for (const status of tierStatuses) {
            if (status.shouldHaveGift && !status.giftInCart) {
                // Need to add gift
                await addFreeGift(status.tier.freeGiftVariantId, status.tier.name);
                changesNeeded = true;
            } else if (!status.shouldHaveGift && status.giftInCart) {
                // Need to remove gift
                await removeFreeGift(status.tier.freeGiftVariantId, status.tier.name);
                changesNeeded = true;
            }
        }

        if (changesNeeded) {
            // Refresh cart UI after all changes
            setTimeout(() => {
                triggerDawnCartRefresh();
            }, 100);
        }

        console.log('=== Evaluation Complete ===\n');
    }

    // ============================================
    // EVENT LISTENERS
    // ============================================

    // 1. On initial page load
    manageAllFreeGifts();

    // 2. Listen for 'Add to Cart' form submissions
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
    addToCartForms.forEach(form => {
        form.removeEventListener('submit', handleFormSubmission);
        form.addEventListener('submit', handleFormSubmission);
    });

    function handleFormSubmission() {
        setTimeout(manageAllFreeGifts, 300);
    }

    // 3. Listen for Dawn theme's native cart update event
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source !== 'free-product-logic') {
                setTimeout(manageAllFreeGifts, 100);
            }
        });
    }

    // 4. Listen for drawer open/close events
    document.addEventListener('drawer:open', function(event) {
        if (event.detail && (event.detail.id === 'CartDrawer' || event.detail.id === 'MiniCart' || event.target.classList.contains('cart-drawer'))) {
            setTimeout(manageAllFreeGifts, 100);
        }
    });
});